export const localStorageMiddleware = ({ getState }: any) => {
	return (next: any) => (action: any) => {
		const result = next(action);
		localStorage.setItem('applicationState', JSON.stringify(getState()));
		return result;
	};
};
